<div class="ziti-page-container lt-skin-page">
  <lib-list-table-header
    title="OIDC Identity Audience Maps"
    subtitle="The OIDC audiences that each user identity is mapped to"
    createLabel="Create OIDC Identity Audience Map"
    infoText="An identity audience map links a user identity to an OIDC audience and the token subject it signs in with."
    [tabs]="tabs"
    [showAdd]="false"
    [blockDelete]="true"
  >
    <span header-icon class="icon-CAs" aria-hidden="true"></span>
  </lib-list-table-header>

  <div class="oidc-audience-maps-panel-row" [class.is-split]="!!list.selected">
    <div class="oidc-audience-maps-list-panel">
      <lib-list-table
        class="lt-skin"
        [tableId]="tableId"
        [initialPageSize]="initialPageSize"
        [options]="tableOptions"
        [columns]="listColumns"
        [rowData]="list.rows"
        [isLoading]="isLoading"
        [hasNext]="list.hasNext"
        [hasPrev]="list.hasPrev"
        [startCount]="list.startCount"
        [endCount]="list.endCount"
        [totalCount]="list.totalCount"
        [filterApplied]="list.filterApplied"
        [filterColumn]="searchFilter"
        [menuItems]="menuItems"
        [accessDenied]="accessDenied"
        filterName="Id"
        entityTypeName="OIDC identity audience maps"
        noItemsImage="nodata"
        [showNoItemsAdd]="false"
        [noItemsReadonly]="true"
      ></lib-list-table>
    </div>

    @if (list.selected; as map) {
      <app-detail-drawer
        eyebrow="OIDC Identity Audience Map Detail"
        [title]="map.subject || map.id"
        [index]="list.selectedIndex"
        [total]="list.rows.length"
        (closed)="list.close()"
        (navigated)="list.step($event)"
      >
        <app-record-detail [sections]="detailSections(map)"></app-record-detail>
      </app-detail-drawer>
    }
  </div>
</div>
